import { QueryEntity } from '@datorama/akita';
import { ApiAppSettingsStore, ApiAppSettingsState } from './api-app-settings.store';
import { first, Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { ApiAppSettingsModel, ApiAppSettingsValueType } from '../models/app-settings/api-app-settings.model';

@Injectable({ providedIn: 'root' })
export class ApiAppSettingQuery extends QueryEntity<ApiAppSettingsState> {
  protected apiAppSettingStore: ApiAppSettingsStore;

  getAllAppSettings$: Observable<ApiAppSettingsModel[]> = this.selectAll();

  getSandboxLoanLpa$: Observable<boolean> = this.select((state) => state?.entities['SandboxLoanLpa']?.value === 'true').pipe(
    first((state) => !!state),
  );

  getSelfDisclosureFullAccessIds$ = this.select((state) => JSON.parse(state?.entities['SelfDisclosure:FullAccessRoleIds']?.value)).pipe(
    first((state) => !!state),
  );

  constructor() {
    const apiAppSettingStore = inject(ApiAppSettingsStore);

    super(apiAppSettingStore);

    this.apiAppSettingStore = apiAppSettingStore;
  }

  /**
   * Be aware of edge cases:
   * - No matching ApiAppSetting --> Observable never emits a value, since it contains `pipe(first((state) => !!state))`.
   * - ApiAppSetting with ValueType JSON --> Value of empty string causes runtime error.
   */
  getAppSettingByName$(name: string): Observable<any> {
    return this.select((state) => {
      if (state?.entities[name]?.valueType === ApiAppSettingsValueType.Boolean) {
        return state?.entities[name]?.value === 'true';
      } else if (
        state?.entities[name]?.valueType === ApiAppSettingsValueType.JsonObject ||
        state?.entities[name]?.valueType === ApiAppSettingsValueType.JsonList
      ) {
        return JSON.parse(state?.entities[name]?.value);
      } else {
        return state?.entities[name]?.value;
      }
    }).pipe(first((state) => !!state));
  }
}
